<div class="container">
    <div class="row mt-5">
        <div class="d-flex justify-content-around">
            <h1 class="text-center ms-auto">Error on payment</h1>
            <span class="me-1 ms-1"></span>
            <mat-icon class="text-danger h-100 me-auto" style="font-size: xx-large; width: auto;">cancel</mat-icon>
        </div>
        <p class="text-center">Your payment was not completed. Please try again or contact support if the issue persists.</p>
        <button mat-raised-button class="w-25 mx-auto mt-5" (click)="onSeePlansClicked()" color="primary">See plans</button>
    </div>
</div>